(function () {
    'use strict';

    angular.module('app')
        .factory('Register', Register);

    /* @ngInject */
    function Register($resource) {
        return $resource('api/admin/user', {}, {});
    }
})();
